"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillGuarantee = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BillGuarantee = _ref => {
  let {
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 37"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M6.628 21.403h5.949m-5.95 4.227h4.49m2.389-20.035v1.922m0 8.646v-1.921m2.402-6.725h-2.402m-2.882 6.725h2.882m0-6.725h-1.2a1.681 1.681 0 1 0 0 3.362h2.4a1.681 1.681 0 1 1 0 3.363h-1.2m-2.882 17.263H2.298A1.207 1.207 0 0 1 1.1 30.289V2.316c0-.671.536-1.216 1.198-1.216h21.56c.661 0 1.197.545 1.197 1.216v10.795m-6.678 15.33-.864 6.509 3.572-2.144 3.573 2.144-.865-6.517m2.294-4.2a5.002 5.002 0 1 1-10.003 0 5.002 5.002 0 0 1 10.003 0Z"
  }));
};
exports.BillGuarantee = BillGuarantee;
BillGuarantee.displayName = "BillGuarantee";